module.exports = __webpack_public_path__ + "img/rs.dab33426.svg";